<template>
  <!-- 图片显示组件，只用于显示，如果要通过disable进行上传或显示，使用imageUpload -->
  <div class="image-show" :style="{'--image-show-width': width, '--image-show-height': height}">
    <img class="image-item" v-show="limit === -1 || id < limit" v-for="(it, id) in imageList" :src="it.url" alt="" :key="id" @click.stop="picPreview(it)"/>
    <div v-if="showPreviewDiv" :id="divId">
      <el-image
          class="hide-image-class"
          :id="id"
          ref="picRef"
          src="https://file.yqgj.ltd/common/WechatIMG1497.jpeg"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="previewList"
          :initial-index="4"
          fit="fill"
      >
      </el-image>
    </div>
  </div>
</template>

<script>

import {watch} from "vue";

export default {
  props: {
    modelValue: {default: ""},
    width: {default: "2.5rem"},
    height: {default: "2.5rem"},
    limit: {default: -1}, // 图片数量限制，-1不限制
    showView: {default: true}, // 是否可以显示预览
  },
  name: "ImageShow",
  components: {
  },
  data() {
    return {
      imageList: [], // 图片信息
      divId: "", // 预览用的div
      id: "", // 预览用的组件
      previewList: [], // 预览用的数组
      showPreviewDiv: false, // 预览用的div
    };
  },
  created() {
    this.id = "imageShow_" + (Math.random() * 9999).toFixed(0);
    this.divId = "divPreView_" + (Math.random() * 9999).toFixed(0);
    this.init();
    watch(() => this.modelValue, ()=> this.init());
  },
  unmounted() {
    const body = document.querySelector('body')
    let div = document.querySelector("#" + this.divId);
    if (div) {
      try {
        body.removeChild();
      } catch (e) {
        console.log("删除失败")
        console.log(e);
      }

    }
  },
  mounted() {
    // 当整个组件渲染完成，将其添加到body
    // this.$nextTick(() => {
    //   const body = document.querySelector('body')
    //   // 将匹配DOM添加到body中
    //   if (body.append) {
    //     body.append(document.querySelector("#" + this.divId));
    //   } else {
    //     body.appendChild(document.querySelector("#" + this.divId))
    //   }
    // })
  },
  methods: {
    init() {
      if (!this.modelValue) {
        this.imageList = [];
        return;
      }
      let arr = [];
      if (this.modelValue.startsWith("[")) {
        // 是list
        let imgArr = JSON.parse(this.modelValue);
        for (let i = 0; i < imgArr.length; i++) {
          arr.push({
            ...imgArr[i],
            url: this.getUrl4Image(imgArr[i].url, process.env.VUE_APP_FILE_URL)
          })
        }
      } else if (this.modelValue.startsWith("{")) {
        let json = JSON.parse(this.modelValue);
        arr.push({
          ...json,
          url: this.getUrl4Image(json.url, process.env.VUE_APP_FILE_URL)
        })
      } else {
        // 兼容老数据或其它地方的外部链接
        arr.push({
          name: 'default',
          url: this.getUrl4Image(this.modelValue, process.env.VUE_APP_FILE_URL)
        })
      }
      this.imageList = arr;
    },
    getUrl4Image(url, baseUrl) {
      if (url.startsWith("http")) {
        return url;
      } else if (url.startsWith("data:")) {
        return url;
      }
      return baseUrl + url;
    },
    // 预览图片
    picPreview(file) {
      if (!this.showView) {
        return;
      }
      this.preview = file.url;
      let arr = [];
      for (let i = 0; i < this.imageList.length; i++) {
        arr.push(this.imageList[i].url);
      }
      this.previewList = arr;

      // 点击预览的时候，向body添加预览div
      if (!this.showPreviewDiv) {
        // 没有div，添加显示
        this.showPreviewDiv = true;
        this.$nextTick().then(() => {
          const body = document.querySelector('body')
          // 将匹配DOM添加到body中
          if (body.append) {
            body.append(document.querySelector("#" + this.divId));
          } else {
            body.appendChild(document.querySelector("#" + this.divId))
          }
          // 预览
          this.$nextTick().then(() => {
            document.querySelector(`#${this.id}`).click();
          })
        });
      } else {
        // 预览
        this.$nextTick().then(() => {
          document.querySelector(`#${this.id}`).click();
        })
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.image-show{
  .image-item{
    width: var(--image-show-width);
    height: var(--image-show-height);
    margin-right: 10px;
    border: 1px solid var(--el-color-info-light-7);
    border-radius: 6px;
    object-fit: contain;
    vertical-align: bottom;
  }
  .image-item:last-of-type{
    margin-right: 0;
  }
}
</style>